import { render, staticRenderFns } from "./dialogAddZhuyuan.vue?vue&type=template&id=65b17c04&scoped=true&"
import script from "./dialogAddZhuyuan.vue?vue&type=script&lang=js&"
export * from "./dialogAddZhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./dialogAddZhuyuan.vue?vue&type=style&index=0&id=65b17c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b17c04",
  null
  
)

export default component.exports